var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add-01"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dark"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8C2 7.58943 2.33283 7.2566 2.7434 7.2566H7.2566V2.7434C7.2566 2.33283 7.58943 2 8 2C8.41057 2 8.7434 2.33283 8.7434 2.7434V7.2566H13.2566C13.6672 7.2566 14 7.58943 14 8C14 8.41057 13.6672 8.7434 13.2566 8.7434H8.7434L8.7434 13.2566C8.7434 13.6672 8.41057 14 8 14C7.58943 14 7.2566 13.6672 7.2566 13.2566V8.7434H2.7434C2.33283 8.7434 2 8.41057 2 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8C2 7.58943 2.33283 7.2566 2.7434 7.2566H7.2566V2.7434C7.2566 2.33283 7.58943 2 8 2C8.41057 2 8.7434 2.33283 8.7434 2.7434V7.2566H13.2566C13.6672 7.2566 14 7.58943 14 8C14 8.41057 13.6672 8.7434 13.2566 8.7434H8.7434L8.7434 13.2566C8.7434 13.6672 8.41057 14 8 14C7.58943 14 7.2566 13.6672 7.2566 13.2566V8.7434H2.7434C2.33283 8.7434 2 8.41057 2 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8C2 7.58943 2.33283 7.2566 2.7434 7.2566H7.2566V2.7434C7.2566 2.33283 7.58943 2 8 2C8.41057 2 8.7434 2.33283 8.7434 2.7434V7.2566H13.2566C13.6672 7.2566 14 7.58943 14 8C14 8.41057 13.6672 8.7434 13.2566 8.7434H8.7434L8.7434 13.2566C8.7434 13.6672 8.41057 14 8 14C7.58943 14 7.2566 13.6672 7.2566 13.2566V8.7434H2.7434C2.33283 8.7434 2 8.41057 2 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8C2 7.58943 2.33283 7.2566 2.7434 7.2566H7.2566V2.7434C7.2566 2.33283 7.58943 2 8 2C8.41057 2 8.7434 2.33283 8.7434 2.7434V7.2566H13.2566C13.6672 7.2566 14 7.58943 14 8C14 8.41057 13.6672 8.7434 13.2566 8.7434H8.7434L8.7434 13.2566C8.7434 13.6672 8.41057 14 8 14C7.58943 14 7.2566 13.6672 7.2566 13.2566V8.7434H2.7434C2.33283 8.7434 2 8.41057 2 8Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd01);
export default __webpack_public_path__ + "static/media/add-01.f82637aac6533639038caa61651f2d3e.svg";
export { ForwardRef as ReactComponent };